import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  compose,
  branch,
  renderComponent,
  setPropTypes,
  defaultProps
} from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'

import Body from 'components/typography/body1/index'

import {
  NOTIFICATION
} from './constants'

import styles from './styles.scss'

const ErrorMessage = ({ message }) => {
  return (
    <Flex auto flex='space-between' align='center'>
      <FontIcon class={styles.icon} value='error'/>
      <Body theme={styles}>{message}</Body>
    </Flex>
  )
}

const InfoMessage = ({ message }) => {
  return (
    <Flex auto flex='space-between' align='center'>
      <FontIcon class={styles.icon} value='info'/>
      <Body theme={styles}>{message}</Body>
    </Flex>
  )
}

const SuccessMessage = ({ message }) => {
  return (
    <Flex auto flex='space-between' align='center'>
      <FontIcon class={styles.icon} value='check_circle'/>
      <Body theme={styles}>{message}</Body>
    </Flex>
  )
}

const withStyle = CSSModules(styles)
const Message = compose(
  defaultProps({
    message: "Empty Message",
    type: NOTIFICATION.INFO.value,
  }),
  setPropTypes({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
  branch(
    ({type}) => type === NOTIFICATION.INFO.value,
    renderComponent(InfoMessage)
  ),
  branch(
    ({type}) => type === NOTIFICATION.ERROR.value,
    renderComponent(ErrorMessage)
  ),
)(SuccessMessage)

export default withStyle(Message)
